import React from "react";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function QtCoaching() {
    const { t } = useTranslation();

    return (
        <>
            <SEO
                title={t('qtcoaching.seoTitle')}
                description={t('qtcoaching.seoDescription')}
                keywords={t('qtcoaching.seoKeywords')}
                url="/qt-coaching"
                schemaType="course"
            />
            <TitleFragment title={t('qtcoaching.pageTitle')} />
        </>
    )
}

export default QtCoaching;